import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync } from "@fortawesome/free-solid-svg-icons"

const PIMS_LABELS: { [key: string]: string } = {
    "api-instinct": "Instinct",
    "api-vetspire": "Vetspire",
    "vetspire": "Vetspire",
    "api-nil-on-prem-avimark": "Avimark",
    "api-on-prem-cornerstone": "Cornerstone",
    "api-on-prem-impromed": "Impromed"
}

interface PimsBadgeProps {
    label?: string
}

export const PimsBadge = ({ label = "PIMS" }: PimsBadgeProps) => {
    const displayLabel = PIMS_LABELS[label] || label
    return (
        <div className="group relative">
            <span className="inline-flex items-center rounded-md bg-blue-50 px-1 py-0.5 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10 gap-x-0.5 shrink-0">
                <FontAwesomeIcon icon={faSync} className="w-2.5 h-2.5" />
                {displayLabel}
            </span>
            <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 hidden group-hover:block w-max z-10">
                <div className="bg-gray-900 text-white text-xs rounded py-1 px-2">
                    Visit synced from {displayLabel}
                </div>
                <div className="w-2 h-2 bg-gray-900 transform rotate-45 absolute left-1/2 -translate-x-1/2 -top-1"></div>
            </div>
        </div>
    )
} 